/*global window*/

/**
 * for some reason we're getting requests with email and password added to url as a query param or in a hash string
 * there's no known place nor flow in our application that would be doing that on our side,
 *
 * there were comments on email thread that this could have been happening in v6 but this version is not deployed anywhere anymore
 *
 * issue with that is that google ads are picking up url with that email password and are raising security issue, threatening to stop serving ads
 *
 *
 * examples or urls:
 * http://www.realtor.com/realestateandhomes-detail/19075-SE-Foster-Rd_Damascus_OR_97089_M20166-03451?email=redacted@example.com&psw=morgan201
 * http://www.realtor.com/realestateandhomes-detail/19075-SE-Foster-Rd_Damascus_OR_97089_M20166-03451#email=redacted@example.com&psw=morgan201
 *
 * urls with query param are handled by ruby middleware making a 301 redirect
 * urls with hash are handled by this workaround
 */

(function (MOVE) {
  "use strict";

  var containsBlacklistedStrings = function (text) {
    var normalized_text = text.toLowerCase();
    var blacklistedStrings = ['@', 'pass', 'mail'];

    return _.some(blacklistedStrings, function (blacklistedString) {
      return normalized_text.indexOf(blacklistedString) !== -1;
    });
  };

  var removeHash = function () {
    var scrollV, scrollH, loc = window.location;
    if ("replaceState" in history) {
      history.replaceState("", document.title, loc.pathname + loc.search);
    } else {
      // Prevent scrolling by storing the page's current scroll offset
      scrollV = document.body.scrollTop;
      scrollH = document.body.scrollLeft;

      loc.hash = "";

      // Restore the scroll offset, should be flicker free
      document.body.scrollTop = scrollV;
      document.body.scrollLeft = scrollH;
    }
  };

  var init = function () {
    if (containsBlacklistedStrings(window.location.hash)) {
      removeHash();
    }
  };

  MOVE.addWorkaround({
    init: init
  });

}(MOVE || {}));



// WEBPACK FOOTER //
// ./_workarounds/workaround_cleanup_hash.js